import { defineMessages } from 'react-intl';

export default defineMessages({
  navigatorExpandedTitle: {
    id: 'navigator.expandedTitle',
    defaultMessage: '收起',
  },
  navigatorCollapsedTitle: {
    id: 'navigator.collapsedTitle',
    defaultMessage: '快速导航',
  },
  navigatorOrderCenter: {
    id: 'navigator.orderCenter',
    defaultMessage: '订单中心',
  },
  navigatorMeCenter: {
    id: 'navigator.navigatorMeCenter',
    defaultMessage: '个人中心',
  },
  navigatorMemberCard: {
    id: 'navigator.memberCard',
    defaultMessage: '会员卡',
  },
  navigatorDishList: {
    id: 'navigator.dishList',
    defaultMessage: '菜单',
  },
  navigatorCommodityList: {
    id: 'navigator.commodityList',
    defaultMessage: '商品列表',
  },
  choseChildDish: {
    id: 'dish.choseChildDish',
    defaultMessage: '选子菜',
  },
  choseGroup: {
    id: 'dish.choseGroup',
    defaultMessage: '选择套餐',
  },
  addToGroup: {
    id: 'dish.addToGroup',
    defaultMessage: '加入套餐',
  },
  choseSpecification: {
    id: 'dish.choseSpecification',
    defaultMessage: '选规格',
  },
  soldout: {
    id: 'dish.soldout',
    defaultMessage: '已售罄',
  },
  monthlySales: {
    id: 'dish.monthlySales',
    defaultMessage: '月售',
  },
  addToShoppingCart: {
    id: 'dish.addToShoppingCart',
    defaultMessage: '加入购物车',
  },
  priceFrom: {
    id: 'dish.priceFrom',
    defaultMessage: '起',
  },
  picked: {
    id: 'dish.picked',
    defaultMessage: '已选',
  },
  atLeast: {
    id: 'dish.atLeast',
    defaultMessage: '必点n份数',
  },
  max: {
    id: 'dish.max',
    defaultMessage: '已达到添加上限',
  },
  registerGoToRegister: {
    id: 'register.goToRegister',
    defaultMessage: '去注册',
  },
  registerDescription: {
    id: 'register.description',
    defaultMessage: '注册会员享受更多福利哟',
  },
  chooseGroupDishCount: {
    id: 'dish.chooseGroupDishCount',
    defaultMessage: '请选择套餐份数',
  },
  mushDishCount: {
    id: 'dish.mushDishCount',
    defaultMessage: '{dishGroupName}/{replaceDishName}为必选菜, 必选{leastCellNum}份',
  },
  childDishOverMax: {
    id: 'dish.childDishOverMax',
    defaultMessage: '{dishGroupName}子菜份数超出可选范围',
  },
  childDishLessMin: {
    id: 'dish.childDishLessMin',
    defaultMessage: '{dishGroupName}未选择足够的子菜份数',
  },
  dishCount: {
    id: 'dish.dishCount',
    defaultMessage: '份',
  },
  mustChecked: {
    id: 'dish.mustChecked',
    defaultMessage: '选',
  },
  notChooseDish: {
    id: 'toast.notChooseDish',
    defaultMessage: '未选择菜品份数',
  },
  pleaseChooseDish: {
    id: 'toast.pleaseChooseDish',
    defaultMessage: '请选择份数',
  },
  chooseDeleteDish: {
    id: 'toast.chooseDeleteDish',
    defaultMessage: '请选择要删除的菜品',
  },
  keepLeastCellNum: {
    id: 'dish.keepLeastCellNum',
    defaultMessage: '此必选菜必须保留起卖份数{leastCellNum}份',
  },
  mustCheckedMinCount: {
    id: 'dish.mustCheckedMinCount',
    defaultMessage: '必点{minimum}',
  },
  notMoreMaxCount: {
    id: 'dish.notMoreMaxCount',
    defaultMessage: '最多选{maximum}份',
  },
  leastCellNum: {
    id: 'dish.leastCellNum',
    defaultMessage: '起卖份数为{leastCellNum}份',
  },
  chooseMinCount: {
    id: 'dish.chooseMinCount',
    defaultMessage: '至少选择{count}份',
  },
  chooseMaxCount: {
    id: 'dish.chooseMaxCount',
    defaultMessage: '最多选择{count}份',
  },
  confirmDelete: {
    id: 'dish.confirmDelete',
    defaultMessage: '确认删除',
  },
  justForVIP: {
    id: 'dish.justForVIP',
    defaultMessage: '专享',
  },
  discountLevel: {
    id: 'dish.discountLevel',
    defaultMessage: '{discountLevel}折优惠',
  },
  price: {
    id: 'dish.price',
    defaultMessage: '价',
  },
  memberPrice: {
    id: 'dish.memberPrice',
    defaultMessage: '会员价',
  },
  noDesc: {
    id: 'dish.noDesc',
    defaultMessage: '暂无',
  },
  goOnPick: {
    id: 'dish.goOnPick',
    defaultMessage: '继续选购',
  },
  descSubtitle: {
    id: 'dish.descSubtitle',
    defaultMessage: '商品介绍',
  },
  guessYouLove: {
    id: 'dish.guessYouLove',
    defaultMessage: '猜你喜欢',
  },
  changeView: {
    id: 'dish.changeView',
    defaultMessage: '换一批',
  },
  serviceBell: {
    id: 'dish.serviceBell',
    defaultMessage: '服务铃',
  },
  send: {
    id: 'dish.send',
    defaultMessage: '发送',
  },
  ignoreStep: {
    id: 'dish.ignoreStep',
    defaultMessage: '跳过',
  },
  loginBeforeOrder: {
    id: 'dish.loginBeforeOrder',
    defaultMessage: '登录后方可点菜下单噢~',
  },
  alreadyOrderedAndRedirecting: {
    id: 'dish.alreadyOrderedAndRedirecting',
    defaultMessage: '已经下单, 自动跳转中...',
  },
  ingredients: {
    id: 'dish.ingredients',
    defaultMessage: '配料',
  },
  inviteYouOrder: {
    id: 'dish.inviteYouOrder',
    defaultMessage: '小伙伴喊你一起点餐哦～',
  },
  scanTableQRCode: {
    id: 'dish.scanTableQRCode',
    defaultMessage: '扫桌台码',
  },
  dishEmpty: {
    id: 'dish.dishEmpty',
    defaultMessage: '购物车是空的',
  },
  must: {
    id: 'dish.must',
    defaultMessage: '必',
  },
  dishMenuGetVipPrice: {
    id: 'dishMenuGetVipPrice',
    defaultMessage: '会员价已享{discountValue}折',
  },
  mustOrder: {
    id: 'dish.mustOrder',
    defaultMessage: '开台必点',
  },
  selfChoose: {
    id: 'dish.selfChoose',
    defaultMessage: '开台自选',
  },
  addedToCart: {
    id: 'dish.addedToCart',
    defaultMessage: '已添加至购物车',
  },
  mustOrderCannotLess: {
    id: 'dish.mustOrderCannotLess',
    defaultMessage: '开台必点菜不可低于{value}份',
  },
  selfChooseModalTitle: {
    id: 'dish.selfChooseModalTitle',
    defaultMessage: '选择开台自选商品',
  },
  selfChooseModalCategoryTitle: {
    id: 'dish.selfChooseModalCategoryTitle',
    defaultMessage: '选择必选商品',
  },
  selfChooseModalNotSelect: {
    id: 'dish.selfChooseModalNotSelect',
    defaultMessage: '还未选择',
  },
  selfChooseLeastSelect: {
    id: 'dish.selfChooseLeastSelect',
    defaultMessage: '至少选择一份',
  },
  selfChooseModalFooter: {
    id: 'dish.selfChooseModalFooter',
    defaultMessage: '继续选购',
  },
  selfChooseCannotLess: {
    id: 'dish.selfChooseCannotLess',
    defaultMessage: '开台自选菜不可低于{value}份',
  },
});



// WEBPACK FOOTER //
// ./src/intl/messages/dish-menu/index.js